import request from '@/utils/request'

export function getDeliveryClerk() {
  return request({
    url: '/ycps/commont/delivery',
    method: 'get'
  })
}

export function getStatisticsDelivery(params) {
  return request({
    url: '/ycps/statistics/delivery',
    method: 'get',
    params
  })
}